angular
	.module 'App.Repository'
	.factory 'TicketRepository', ['BaseRepository', (BaseRepository) ->
		class TicketRepository extends BaseRepository
			@resource = '/tickets'
			@isRestricted = true

		return new TicketRepository
	]
